import {
	ACCOUNTANT_LIST_SCREEN_SLUG,
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../../common/constants";
import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EmptyList,
	EnhancedSnackbar,
	RouterLinkButton,
} from "@websential/cosmic-v20";
import { Box, Button, Grid, useTheme } from "@mui/material";
import {
	EnhancedButtonPrimeReactSeverity,
	useNavigateToLogout,
} from "../../../common/Common";
import { IAccountant, IGetListRequest } from "../../../models";
import { IResponse, IServerError } from "../../../models/common";
import { Link, useNavigate } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
	setAppBarSelectedItem,
	setSelectedAccountant,
	setSelectedAccountantName,
} from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { AccountantService } from "../../../services";
import { EnhancedButtonPrimeReact } from "../../EnhancedButtonPrimeReact";
import { IAppState } from "../../../store/reducers";
import { PrimeDataGrid } from "../../PrimeDataGrid";
import { setSelectedActivityLogActions } from "../../../store/actions/activityLogActions";
import { setSelectedDrawerOptionsMenu } from "../../../store/actions/drawerMenuOptionsActions";
import { setSelectedStickyNavBar } from "../../../store/actions/stickyNavBarActions";

// import { toSnake } from "common/methods";








// import { clearError } from "store/actions/viewStateActions";





// import { EnhancedDataGrid } from "../../EnhancedDataGrid";
// import { newData } from "services";
// import OnRowDelete from "./OnRowDelete";






// import { fetchAccountantRequest } from "store/actions/getListActions";

export interface IAccountantList { }
const ACCOUNTANT_LIST_QUERY_KEY: any = "accountants-list";

const useAccountants = (params: IGetListRequest, isAdminUser: any) =>
	useQuery({
		queryKey: ["accountants-list", params, isAdminUser],
		queryFn: () => AccountantService.getAccountants(params, isAdminUser),
		refetchOnWindowFocus: false
	});

export const AccountantList: React.FC<IAccountantList> = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const navigateToLogout = useNavigateToLogout();

	// for delete row Purpose
	const queryClient = useQueryClient();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [selectedRowsValues, setSelectedRowsValues] = useState([]);

	// Bulk Delete
	const [bulkDelete, setBulkDelete] = useState<boolean>(false);
	const [bulkAccountantId, setBulkAccountantId] = useState<any>({});
	const [bulkAccountantDelete, setBulkAccountantDelete] =
		useState<boolean>(false);

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "accTitle",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const { isPending, data } = useAccountants(queryParams, isAdminUser); //useQuery('accountants-list', AccountantService.accountantList, { refetchOnWindowFocus: false });
	const accountantList: any = data;


	useEffect(() => {
		if (isAdminUser !== 400) {
			if (
				accountantList &&
				accountantList.items &&
				accountantList.items.length === 1 &&
				zeroAccountant === true
			) {
				dispatch(setSelectedAccountant(accountantList.items[0]));
				let path = "/accountants/clients";
				navigate(path);
			} else if (
				accountantList &&
				accountantList.items &&
				accountantList.items.length === 0 &&
				zeroAccountant === true
			) {
				dispatch(setSelectedAccountant({ id: "0" })); //default Accountant id gets from backend
				let path = "/clients";
				navigate(path);
			}
		}
	}, [accountantList]);

	const { message, componentState } = useSelector(
		(state: IAppState) => state.viewState
	);

	// const { accountantList } = useSelector(
	//   (state: IAppState) => state.accountant
	// );

	const [openDialog, setDialogOpen] = useState(false);
	const [selectedIds, setSelectedIds] = useState("");
	const [statusValue, setStatusValue] = useState("");
	const [apiAction, setApiAction] = useState("");
	const [emptyList, setEmptyList] = useState(false);
	const [searchText, setSearchText] = useState({});
	const [zeroAccountant, setzeroAccountant] = useState<any>(true);

	// for delete row
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [accountantId, setAccountantId] = useState<any>(0);

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField && requestParams.sortField === "resource.name"
					? "accTitle"
					: requestParams.sortField
						? requestParams.sortField
						: "accTitle",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};
		// if (requestParams.sort) {
		//   const [sortBy, sortDirection] = requestParams.sort.split(",");
		//   dispatchParams.order_by = toSnake(sortBy);
		//   dispatchParams.order_direction = sortDirection;
		// }
		setQueryParams(dispatchParams);
	}, []);

	const onSearchButtonClicked = () => {
		setQueryParams(searchText);
		setzeroAccountant(false);
	};

	const onRowEditClicked = useCallback((params: IAccountant) => {
		// alert(`Edit row with ID: ${params.row.id} has been clicked!`);
		let path = `/accountants/setup/${params.id}`;
		navigate(path);
	}, []);

	const onCloseHandler = () => {
		setDialogOpen(false);
	};

	const deleteAccountantField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			// deleteAccountantById(comapnyId);
			setDialogOpen(false);

			// setSnackbarData({
			// 	open: true,
			// 	message: "Accountant cannot be deleted!",
			// 	severity: "error",
			// });
			let delPayload: any = {
				accountantId: accountantId,
				navigateToLogout: navigateToLogout,
			};
			deleteAccountantById(delPayload);
		}
	};
	const onRowDeleteClicked = useCallback((params: IAccountant) => {
		setDialogOpen(true);
		setSingleDelete(true);
		setAccountantId(params.id);
	}, []);

	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const { isPending: isDeleting, mutate: deleteAccountantById } = useMutation({
		mutationFn: AccountantService.deleteById,
		onSuccess: (res: string | IServerError | IResponse | any) => {
			if (res) {
				// remove the cache of the Accountant fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: res.message ? res.message : "Something went wrong.",
					severity: res.status === false ? "error" : res.success === false ? "error" : "success",
				});

				if (res.success !== false) {
					return queryClient.invalidateQueries(ACCOUNTANT_LIST_QUERY_KEY);
				}
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
		},
		onError: (err) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	}
	);

	const onKeyFieldClickHandler = (clickedRow: any) => {
		dispatch(setSelectedAccountant(clickedRow));
		// dispatch(setSelectedAccountantName(clickedRow));
	};

	//bulk delete

	const { isPending: isBulkDeleting, mutate: deleteBulkAccountants } =
		useMutation({
			mutationFn: AccountantService.delBulkAccountants,
			onSuccess: (res: any | string | IServerError | IResponse) => {
				if (typeof res === "object") {
					// remove the cache of the Year fields since we just added a new field.
					setSnackbarData({
						open: true,
						message: res.message ? res.message : "Something went wrong.",
						severity: res.status === false ? "error" : "success",
					});

					setBulkAccountantDelete(false);
					return queryClient.invalidateQueries(ACCOUNTANT_LIST_QUERY_KEY);
				} else {
					setSnackbarData({
						open: true,
						message: res.message
							? res.message
							: "Something went wrong, try again later!",
						severity: res.status === false ? "error" : "success",
					});
				}
				setBulkAccountantDelete(false);
			},
			onError: (err: any) => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: err.message,
					severity: "error",
				});
				setBulkAccountantDelete(false);
			},
		});

	// For Bulk Delete
	const deleteBulkAccountantField = () => {
		if (bulkDelete) {
			setBulkDelete(false);
			let payload = {
				accountantsIds: bulkAccountantId,
				navigateToLogout: navigateToLogout,
			};
			deleteBulkAccountants(payload);
			setDialogOpen(false);

			// setSnackbarData({
			// 	open: true,
			// 	message: "Accountant cannot be deleted!",
			// 	severity: "error",
			// });
		}
	};

	const onRowMultipleDeleteClicked = (params: any) => {
		let bulkDeletePayload = {
			comapnyIds: { comapnyIds: params },
		};
		setDialogOpen(true);
		setBulkDelete(true);
		setApiAction("delete");
		setBulkAccountantId(bulkDeletePayload);
		setBulkAccountantDelete(true);
	};

	const selectionToolbar = useCallback(
		(selectedItems: any) => {
			setSelectedIds(selectedItems);
			if (selectedItems.length) {
				return (
					<Box>
						{/* <Button
							onClick={() => onRowMultipleDeleteClicked(selectedItems)}
							variant="contained"
							color="error"
						>
							Delete
						</Button> */}
					</Box>
				);
			}
			return (
				<>
					{isAdminUser === 400 ? (
						<Box>
							{/* <RouterLinkButton to="/accountants/setup" text="Add Accountant" /> */}
							{/* <EnhancedButtonPrimeReact
								label="Add Accountant"
								raised
								severity={EnhancedButtonPrimeReactSeverity.Success}
								to="/accountants/setup"
							/> */}
						</Box>
					) : (
						<></>
					)}
				</>
			);
		},
		[selectedRowsValues]
	);

	const getColumnMinWidth = (field: any) => {
		const maxContentWidth = Math.max(
			...accountantList?.items.map((row: any) => String(row[field]).length * 8)
		); // Assuming an average character width of 8px
		return maxContentWidth + 16; // Add some padding
	};

	const onClickHandler = (clickedRow: any) => {
		dispatch(setSelectedAccountant(clickedRow));
		dispatch(setSelectedAccountantName(clickedRow));
		dispatch(setAppBarSelectedItem({ appBarSelectedItem: "Home" }));
	};

	const upadtedAccountantListItems = useMemo(() => {
		return (
			accountantList &&
			accountantList.items &&
			accountantList?.items.map((item: any) => ({
				...item,
				accTitle: (
					<Link
						to={`/accountants/clients`}
						className="no-underline"
						style={{ color: theme.palette.primary.light }}
						onClick={() => onClickHandler(item)}
					>
						{item.accTitle}
					</Link>
				),
				email: item.email?.charAt(2) === "*" ? "Unmask to view" : item.email,
			}))
		);
	}, [accountantList]);

	// use three steps scenario if have threen items from travel agency project
	const expandedLabels = ["Accountant"];
	const expandedAccountantListOrSetupItem = "List"; // Special case for "List" under "City Tax"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Accountant" &&
				item.label === expandedAccountantListOrSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedAccountantListOrSetupItem && "/accountants/list",
			};
			return enhancedItem;
		});
	};
	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: ACCOUNTANT_LIST_SCREEN_SLUG,
				accountantName: "",
				activityType: "activity_type=delete",
				activityLogVisibility: true,
			})
		);
		dispatch(setSelectedStickyNavBar({ isSticky: false }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	const image =
		"https://taxslips.blob.core.windows.net/taxslips-public-images-container/empty_employee_list.png";

	return accountantList &&
		accountantList.items &&
		accountantList.items.length === 0 &&
		isAdminUser === 400 &&
		zeroAccountant === true ? (
		<EmptyList
			showImage={true}
			imagePath={image}
			heading={`There's nothing! Add Accountant to proceed`}
			content={`You can add accountant by directly clicking on add accountant button.`}
			testId={"accountant-empty-list"}
			showAddButton={true}
			addButtonLabel={"Add Accountant"}
			navigateToAdd={"/accountants/setup"}
			showImportButton={false}
			showImportXmlButton={false}
		/>
	) : (
		<>
			<Grid
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
			// className={classes.list}
			>
				{/* <EnhancedDialog
        dialogTitle="Please Confirm"
        key="dialog-box"
        testId="dialog"
        onCloseHandler={onCloseHandler}
        open={openDialog}
        dialogContent={
          <Typography variant="subtitle1">Are you sure?</Typography>
        }
        dialogAction={
          <Grid>
            <Button
              autoFocus
              variant="contained"
              onClick={onCloseHandler}
              color="default"
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
              autoFocus
              variant="contained"
              onClick={callAction}
              color="primary"
              className={classes.button}
            >
              ok
            </Button>
          </Grid>
        }
      /> */}
				<DeleteConfirmationDialog
					open={openDialog}
					deleteActionHandler={
						bulkAccountantDelete === true
							? deleteBulkAccountantField
							: deleteAccountantField
					}
					cancelActionHandler={onCloseHandler}
					testId="accountant-field-tab-confirmation-dialog"
				/>
				{/* <EnhancedDataGrid
          keyField={accountantList ? accountantList.keyField : undefined}
          onKeyFieldClickHandler={onKeyFieldClickHandler}
          columns={accountantList && accountantList.headerColumns ? columnsWithMinWidth : []}
          rows={accountantList?.items}
          selectionEnabled={isAdminUser === 400 ? true : false}
          autoHeight={true}
          allowSearching={true}
          onSearchButtonClicked={onSearchButtonClicked}
          searchFieldPlaceholder={"Search by Account Title..."}
          rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
          selectionToolbar={selectionToolbar}
          onRowEditClicked={onRowEditClicked}
          // onRowDeleteClicked={<OnRowDelete name={ACCOUNTANT_LIST_QUERY_KEY}/>}
          onRowDeleteClicked={onRowDeleteClicked}
          // initialPage={0}
          initialPageSize={INITIAL_PAGE_SIZE}
          disableColumnMenu={true}
          showRowActionsColumn={isAdminUser === 400 ? true : false}
          autoPageSize={false} //
          showIndexColumn={true}
          testId="accountant-list-grid"
          sortingMode="server"
          filterMode="server"
          paginationMode="server"
          onRequestParamsChange={onRequestParamsChange}
          onSearchCrossClicked={(value) => setzeroAccountant(value)}
          totalRowsCount={accountantList?.total}
          isPending={isPending || isDeleting || isBulkDeleting}
          rowIdGetter={(row) => row.id}
          searchDebouncingDelay={SEARCH_DEBOUNCE_DELAY_IN_SECONDS}
          shouldMask={false}
		  /> */}
				{/* <OnRowDelete name={ACCOUNTANT_LIST_QUERY_KEY} id={9}/> */}
				{/* <OnRowDelete name={ACCOUNTANT_LIST_QUERY_KEY} id={accountantId}/> */}

				<BackdropCircularProgress
					open={
						isPending || isDeleting || isBulkDeleting
					}
					testId="employee-list"
				/>
				<PrimeDataGrid
					columns={accountantList ? accountantList.headerColumns : []}
					rows={
						accountantList && upadtedAccountantListItems
							? upadtedAccountantListItems
							: []
					}
					showIndexColumn={true}
					// showChecboxColumn={isAdminUser === 400 ? true : false}
					showChecboxColumn={false}
					showSettingColumn={true}
					onRowEditClicked={onRowEditClicked}
					onRowDeleteClicked={onRowDeleteClicked}
					// onKeyFieldClickHandler={onKeyFieldClickHandler}
					isLoading={isPending || isDeleting || isBulkDeleting}
					onSnackbarMessageData={(value: any) => setSnackbarData(value)}
					totalRecords={
						accountantList && accountantList.total ? accountantList.total : 0
					}
					initialPageSize={INITIAL_PAGE_SIZE}
					rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
					onRequestParamsChange={onRequestParamsChange}
					selectionToolbar={selectionToolbar}
					selectedRowsValues={(value: any) => setSelectedRowsValues(value)}
					searchFieldPlaceholder={"Search..."}
					changeLoginForGetEmptyItemsBySearchQuery={(value: any) =>
						setzeroAccountant(value)
					}
					pageTitle={"Accountants"}
				/>
			</Grid>
			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={"accountant-field-tab-list-snackbar"}
				open={snackbarData.open}
			/>
		</>
	);
	// switch (componentState) {
	//   case ComponentState.LOADING:
	//     return (
	//       <CircularProgress
	//         size={24}
	//         data-testid="circular-progress"
	//         className={classes.loader}
	//       />
	//     );
	//   case ComponentState.ERROR:
	//     return (
	//       <div>Error loading component data</div>
	//       // <ErrorState
	//       //   testId="error-container"
	//       //   message={message}
	//       //   onClick={() => {
	//       //     clearError();
	//       //     let dispatchParams = {
	//       //       search_query: "",
	//       //       order_by: "accTitle",
	//       //       order_direction: "asc",
	//       //       page: 1,
	//       //       size: 50,
	//       //     };
	//       //     dispatch(accountantListRequest(dispatchParams));
	//       //   }}
	//       // />
	//     );
	//   case ComponentState.DATA:
	//     return emptyList ? (
	//       <accountantList />
	//     ) : (
	//       <Grid
	//         item
	//         xs={12}
	//         sm={12}
	//         md={12}
	//         lg={12}
	//         xl={12}
	//         className={classes.list}
	//       >
	//         {/* <EnhancedDialog
	//           dialogTitle="Please Confirm"
	//           key="dialog-box"
	//           testId="dialog"
	//           onCloseHandler={onCloseHandler}
	//           open={openDialog}
	//           dialogContent={
	//             <Typography variant="subtitle1">Are you sure?</Typography>
	//           }
	//           dialogAction={
	//             <Grid>
	//               <Button
	//                 autoFocus
	//                 variant="contained"
	//                 onClick={onCloseHandler}
	//                 color="default"
	//                 className={classes.button}
	//               >
	//                 Cancel
	//               </Button>
	//               <Button
	//                 autoFocus
	//                 variant="contained"
	//                 onClick={callAction}
	//                 color="primary"
	//                 className={classes.button}
	//               >
	//                 ok
	//               </Button>
	//             </Grid>
	//           }
	//         /> */}
	//         <EnhancedDataGrid
	//           columns={accountantList ? accountantList.headerColumns : []}
	//           rows={accountantList?.items}
	//           selectionEnabled={true}
	//           autoHeight={true}
	//           allowSearching={true}
	//           rowsPerPageOptions={[10, 25, 50, 100]}
	//           selectionToolbar={selectionToolbar}
	//           onRowEditClicked={onRowEditClicked}
	//           onRowDeleteClicked={onRowDeleteClicked}
	//           initialPageSize={accountantList?.size}
	//           disableColumnMenu={true}
	//           showRowActionsColumn={true}
	//           autoPageSize={true}
	//           showIndexColumn={true}
	//           testId="accountant-list-grid"
	//           sortingMode="server"
	//           filterMode="server"
	//           paginationMode="server"
	//           onRequestParamsChange={onRequestParamsChange}
	//           totalRowsCount={accountantList?.total}
	//           isPending={false}
	//           rowIdGetter={(row) => row.id}
	//           searchDebouncingDelay={2000}
	//           shouldMask={false}
	//         />
	//       </Grid>
	//     );
	//   default:
	//     return null;
	// }
};
